import axios from 'axios'
import { CADASTRAR_ROTA_RETORNO } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function cadastrarRotaRetorno (cod, idEmpresa) {
  const url = `${URL}/rota/${cod}/empresa/${idEmpresa}/cadastrar-retorno`;
  return dispatch => axios.post(url,null , SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: CADASTRAR_ROTA_RETORNO,
        payload: response
      })
  );
}
